// Authorize.Net AcceptUI configuration. The client key is a PUBLIC key (safe to ship in the
// bundle) that is distinct from the Transaction/Signature keys, which must never reach the
// browser. The card is captured inside Authorize.Net's hosted lightbox into an opaque nonce;
// only that nonce is sent to our API. Payment capture is skipped when these are absent (see
// useAcceptUi.isConfigured), and checkout then places no order at all (#429). The same two keys are also substituted into the static AcceptUI
// host button in index.html — that copy is what the lightbox actually uses.
export const authNetConfig = {
    apiLoginId: import.meta.env.VITE_AUTHNET_API_LOGIN_ID ?? "",
    clientKey: import.meta.env.VITE_AUTHNET_CLIENT_KEY ?? "",
    // Sandbox (jstest) vs production (js) host. Injected lazily by useAcceptUi — see that file for
    // why the script is NOT a static tag in index.html.
    acceptUiUrl: import.meta.env.VITE_AUTHNET_ACCEPTUI_URL ?? "",
    // The v1/Accept.js script (bank-account tokenization for ACH, #296) — a SEPARATE vendor
    // script from v3/AcceptUI.js above: it defines window.Accept and does no DOM binding, no
    // overlay, no scrollTo. Injected lazily by useAcceptJs. Optional: ACH capture is simply
    // unavailable while blank.
    acceptUrl: import.meta.env.VITE_AUTHNET_ACCEPT_URL ?? "",
    // "sandbox" | "production" — display-only; the real host selection is acceptUiUrl above.
    environment: import.meta.env.VITE_AUTHNET_ENVIRONMENT ?? "sandbox",
};

// The single predicate for "can this environment take a payment at all" — the two public
// keys. ONE definition on purpose: useAcceptUi, useAcceptJs and Checkout all gate on it, and
// a drifting hand-copy would let PaymentForm render "checkout is unavailable" while Checkout
// still offered Place Order or waited on a surcharge quote.
// Note this deliberately excludes the script URLs: each hook adds its own URL leg (a missing
// VITE_AUTHNET_ACCEPT_URL disables ACH only, leaving the card path intact).
export const isCardPaymentConfigured = (): boolean =>
    Boolean(authNetConfig.apiLoginId && authNetConfig.clientKey);
